import { mapState } from "pinia";
import { SmartFeedEntityDynamicElementMixin } from "%/dynamic-component-editor/mixins/smart-feed-entity-dynamic-element-mixin";
import { useFanPublicationStore } from "%/dynamic-component-editor/stores/fan-publication-store";

// ApplyToCollaboratePage element host. Previously consumed
// `~/stores/user-store` (outside the editor directory tree). The
// editor's isolation rule forbids that, and edit-mode rendering
// only needs the example entity anyway. Surface the applicant
// computeds from the example entity instead so ApplyToCollaborateButton
// and ApplyToCollaborateMessage stay self-contained.
export const ApplyToCollaboratePageElementMixin = {
  extends: SmartFeedEntityDynamicElementMixin,
  computed: {
    ...mapState(useFanPublicationStore, [
      "publicationId",
      "orgId",
    ]),
    currentEmail() {
      return this.entity?.email ?? "applicant@example.com";
    },
    firstName() {
      return this.entity?.firstName ?? "Applicant";
    },
    lastName() {
      return this.entity?.lastName ?? "Collaborator";
    },
    applicantName() {
      return `${this.firstName} ${this.lastName}`.trim();
    },
    applicationMessageKey() {
      return "collaboration-application-message";
    },
    defaultRole() {
      return "contributor";
    },
  },
  methods: {
    getExampleEntity() {
      return {
        firstName: "Applicant",
        lastName: "Collaborator",
        email: "applicant@example.com",
      };
    },
    getRealEntity() {
      return this.getExampleEntity();
    },
  },
};
